import server from '../../public/server/server'
const systemApi = {
    //资源
    saveResource:server.requestPath +  '/rbac/saveResource', // 新增或编辑资源信息
    resourceTree:server.requestPath +  '/rbac/resourceTree', // 获取系统资源树
    deleteResource:server.requestPath +  '/rbac/deleteResource', //删除资源信息
     // 角色
    saveRole:server.requestPath +  '/rbac/saveRole', //新增、编辑角色
    roleAuthorization:server.requestPath +  '/rbac/roleAuthorization', //角色授权
    etRoleDetail:server.requestPath +  '/rbac/etRoleDetail', //角色详情
    deleteRole:server.requestPath +  '/rbac/deleteRole', //删除角色
    roleResourceTree:server.requestPath +  '/rbac/roleResourceTree', //角色资源树
    getRoleList:server.requestPath +  '/rbac/getRoleList', //角色列表
    getRoleDetail:server.requestPath +  '/rbac/getRoleDetail', //角色详情
	//rtsp模板和子模块管理
	rtspQueryListByPage:server.requestPath +  '/rtsp/queryListByPage', //分页查询
	rtspSave:server.requestPath +  '/rtsp/save', //增加/编辑
	rtspFindById:server.requestPath +  '/rtsp/findById', //查询详情
	rtspDel:server.requestPath +  '/rtsp/del', //删除


	platformQueryListByPage:server.requestPath +  '/sysPlatform/queryListByPage', //分页查询
	platformSave:server.requestPath +  '/sysPlatform/save', //增加/编辑
	platformFindById:server.requestPath +  '/sysPlatform/findById', //查询详情
	platformDel:server.requestPath +  '/sysPlatform/del', //删除
	//指挥中心用户
	managePage:server.requestPath +  '/user/managePage', //指挥中心用户列表

    //第三方公司配置
    companyQueryList:server.requestPath +  '/company/queryList', //公司列表
    companyDel:server.requestPath +  '/company/del', //删除
    companySave:server.requestPath +  '/company/save', //保存或修改
    companyCreateKeyInfo:server.requestPath +  '/company/createKeyInfo', //获取key的生成信息

    // 出警员日历
    findListByDate:server.requestPath +  '/user/sign/findListByDate', //获取某天的签到记录/不传用户默认当前用户-----当前的签到和签退
    queryByDate:server.requestPath +  '/user/sign/queryByDate', //-------查询本月的签到纪录
    userTrack:server.requestPath +  '/user/track/userTrack', //-------获取轨迹
    queryUserByDate:server.visualIntercom +  '/alarm/queryUserByDate', //-------查询用户当 天/月 分派任务列表

    // 应用平台管理
    platformAppList:server.requestPath + '/platform/app/listPage', //分页 | 列表
    platformAppCreateKeyInfo:server.requestPath + '/platform/app/createKeyInfo', //创建密钥
    platformAppSave:server.requestPath + '/platform/app/save', //保存或修改
    platformAppDel:server.requestPath + '/platform/app/del', //删除


    //wvp视频管理
    wvpAppList:server.requestPath + '/wvp/queryList', //分页 | 列表
    wvpAppSave:server.requestPath + '/wvp/save', //保存或修改
    wvpAppDel:server.requestPath + '/wvp/del', //删除
    queryMyList: server.requestPath + '/wvp/queryMyList',//平台添加国标地址
    syncArea: server.requestPath + '/wvb/syncArea',//平台添加国标地址
}

export {
    systemApi
}
